import { useCallback } from "react";

import { useAppDispatch, useAppSelector } from "@/data/hooks";
import { setPendingSnapshot } from "@/features/authority/authority-slice/authority-slice";
import { selectAnswerSnapshot } from "@/features/authority/authority-slice/selectors";
import { AnswerBlockFragment } from "@/generated/graphql";
import { type Snapshot } from "@/stores/snapshot";

interface PendingDialogueProps {
  dialogueId: string;
}

/**
 * We use centralised Snapshot Queue to save completed Video Responses to
 * Socratic Dialogues for Student Submissions
 */
export function useQueueVideoResponse(props: {
  answerBlock: AnswerBlockFragment;
}) {
  const { answerBlock } = props;
  const dispatch = useAppDispatch();

  const snapshot = useAppSelector((state) =>
    selectAnswerSnapshot(state, answerBlock.id)
  );

  const currentVersion = snapshot?.version ?? 0;

  return useCallback(
    (props: PendingDialogueProps) => {
      const snapshot: Snapshot = {
        version: currentVersion + 1,
        answerDialogueId: props.dialogueId,
      };
      dispatch(
        setPendingSnapshot({
          answerBlockId: answerBlock.id,
          snapshot,
          updateLocalSnapshot: true,
        })
      );
    },
    [dispatch, answerBlock.id, currentVersion]
  );
}
